var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFreeze = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5951 5.86369L13.3394 3.11942L12.345 2.12501L9.60074 4.86928L10.5951 5.86369Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97624 14.5005L7.23196 17.2447L8.22637 18.2391L10.9706 15.4949L9.97624 14.5005Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.345 18.2391L9.60074 15.4949L10.5951 14.5005L13.3394 17.2447L12.345 18.2391Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2264 2.12501L10.9707 4.86928L9.97627 5.86368L7.232 3.11941L8.2264 2.12501Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48202 0.999992L9.48203 19.0006L10.8883 19.0006L10.8883 0.999992L9.48202 0.999992Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54858 11.8006L2.79984 10.7961L2.43586 12.1545L6.1846 13.159L6.54858 11.8006Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3377 8.01819L18.0864 9.02266L18.4504 7.66428L14.7017 6.65981L14.3377 8.01819Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3911 4.09745L15.3866 7.84619L14.0282 7.48221L15.0327 3.73347L16.3911 4.09745Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49516 15.7214L5.49963 11.9726L6.85801 12.3366L5.85354 16.0854L4.49516 15.7214Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.893 15.1964L18.482 6.19614L17.7788 4.97825L2.18985 13.9786L2.893 15.1964Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7133 12.3366L14.7178 16.0853L16.0762 15.7214L15.0717 11.9726L13.7133 12.3366Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54314 7.48223L5.53867 3.73349L4.18029 4.09747L5.18476 7.84621L6.54314 7.48223Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12098 7.66429L5.86972 6.65982L6.2337 8.0182L2.48495 9.02267L2.12098 7.66429Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1355 12.1545L14.3867 13.159L14.0228 11.8006L17.7715 10.7961L18.1355 12.1545Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.482 13.8045L2.89301 4.80417L2.18986 6.02206L17.7788 15.0224L18.482 13.8045Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFreeze);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/freeze.c9cbf891f9618a3fc9608df63044c5a5.svg";